<script lang="ts">
	import { resolve } from '$app/paths';
</script>

<!-- Real anchor (was a clickable div with aria-hidden): keyboard-focusable and
     named for screen readers. The crown glyph itself is decorative. -->
<a
	href={resolve('/leaderboard')}
	aria-label="Leaderboard"
	class="inline-flex items-center justify-center rounded-full p-2 text-lg transition-transform hover:scale-110 focus-visible:ring-2 focus-visible:ring-primary-500/60 focus-visible:outline-none"
>
	<span aria-hidden="true">👑</span>
</a>
